import React from 'react';
import 'react-photo-view/dist/react-photo-view.css';
import AppRoutes from './routes/routes';
import BlockDevTools from './components/BlockDevTools';
import { Bounce, ToastContainer } from "react-toastify";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { Provider } from "react-redux";
import { store } from "./store";

const queryClient = new QueryClient();

function App() {

  return (
    <>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <BlockDevTools />
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            transition={Bounce}
          />
          <AppRoutes />
        </QueryClientProvider>
      </Provider>



    </>

  );
}

export default App;